/**
 * Eros product badge rotator — ADR-139 living grid parity.
 * Desync start: hash(productId) % intervalMs; cross-fade 300ms; pause offscreen / hidden tab.
 */
(function () {
  'use strict';

  var FADE_MS = 300;
  var DEFAULT_INTERVAL_MS = 2000;
  var VISIBILITY_THRESHOLD = 0.1;
  var reduceMotion = false;

  try {
    reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {
    reduceMotion = false;
  }

  function hashId(id) {
    var s = String(id || '');
    var h = 0;
    for (var i = 0; i < s.length; i++) {
      h = (h << 5) - h + s.charCodeAt(i);
      h |= 0;
    }
    return Math.abs(h);
  }

  function itemsOf(host) {
    return Array.prototype.slice.call(
      host.querySelectorAll('[data-badge-item], .eros-product-badge-host__item')
    );
  }

  function setActive(items, index) {
    for (var i = 0; i < items.length; i++) {
      var on = i === index;
      items[i].classList.toggle('is-active', on);
      if (on) {
        items[i].removeAttribute('aria-hidden');
      } else {
        items[i].setAttribute('aria-hidden', 'true');
      }
    }
  }

  function bindHost(host) {
    if (!host || host.dataset.bound === '1') return;
    host.dataset.bound = '1';

    if (host.hasAttribute('data-static') || reduceMotion) return;

    var items = itemsOf(host);
    if (items.length <= 1) return;

    var intervalMs =
      parseInt(host.getAttribute('data-interval-ms'), 10) || DEFAULT_INTERVAL_MS;
    if (intervalMs <= 0) return;

    var index = 0;
    var timer = null;
    var startTimer = null;
    var intersecting = true;
    var pageVisible = !document.hidden;

    function clearTimers() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      if (startTimer) {
        clearTimeout(startTimer);
        startTimer = null;
      }
    }

    function advance() {
      if (!pageVisible || !intersecting) return;
      index = (index + 1) % items.length;
      setActive(items, index);
    }

    function syncRotation() {
      clearTimers();
      if (!pageVisible || !intersecting || reduceMotion) return;

      var productId = host.getAttribute('data-product-id') || '';
      var phaseMs = hashId(productId) % intervalMs;

      startTimer = setTimeout(function () {
        startTimer = null;
        if (!pageVisible || !intersecting) return;
        advance();
        timer = setInterval(advance, intervalMs);
      }, phaseMs);
    }

    function onVisibilityChange() {
      pageVisible = !document.hidden;
      if (pageVisible) {
        syncRotation();
      } else {
        clearTimers();
      }
    }

    document.addEventListener('visibilitychange', onVisibilityChange);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          intersecting = entry.isIntersecting && entry.intersectionRatio >= VISIBILITY_THRESHOLD;
          if (intersecting) {
            syncRotation();
          } else {
            clearTimers();
          }
        },
        { threshold: [0, VISIBILITY_THRESHOLD, 0.25, 0.5, 1] }
      );
      io.observe(host);
      host._erosBadgeIo = io;
    }

    host._erosBadgeTeardown = function () {
      clearTimers();
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (host._erosBadgeIo) {
        host._erosBadgeIo.disconnect();
        host._erosBadgeIo = null;
      }
    };

    // Ensure only first chip is visible before first tick.
    setActive(items, 0);
    syncRotation();
  }

  function initAll() {
    var hosts = document.querySelectorAll(
      '[data-eros-product-badges]:not([data-static])'
    );
    for (var i = 0; i < hosts.length; i++) {
      bindHost(hosts[i]);
    }
  }

  var scheduled = false;
  function scheduleInit() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', scheduleInit);

  if ('MutationObserver' in window) {
    var mo = new MutationObserver(scheduleInit);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.ErosProductBadges = {
    init: initAll,
    _fadeMs: FADE_MS,
  };
})();
